<alaris-dialog [closeAction]="close.bind(this)" [confirmAction]="confirm.bind(this)" [loading$]="rulesService.loading$"
			   size="md">
	<h6 slot="header">{{ 'rules.removingDialog' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.rule.ruleId }} - {{ data.rule.name }}</strong></h3>
	</div>
</alaris-dialog>